import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import './FormComponents.scss';

const TextArea = ({ label, gif, name, isRequired, ...rest }) => {
  const { t } = useTranslation();
  return (
    <div className="question">
      <div className="question__icon">
        <img src={require('assets/images/tablet2.png')}/>
      </div>
      <div className="question__header">
        <label htmlFor={name}>{label}</label>
      </div>
      {!!gif && (
        <div className="question__gif">
          <LazyLoadImage effect="opacity" src={gif} alt="this is a Gif" />
        </div>
      )}
      <div className="question__textarea">
        <Field 
          {...rest} 
          rows={5} 
          as="textarea" 
          id={name} 
          name={name} 
          className="input-area" 
          placeholder={t('placeholder.textarea')}
        />
      </div>
    </div>
  );
};

TextArea.defaultProps = {
  gif: '',
};

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  gif: PropTypes.string,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
};

export default TextArea;
 